import script from "./PayrollPeriod.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollPeriod.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__